// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body {
  padding: 0;
}

.profile-pic {
  position: relative;
  width: 140px;
  height: 100px;
  border: 1px solid #e2e2e2;
  margin: 0 auto;
  cursor: pointer;
}
.profile-pic:hover span {
  height: 35px;
  line-height: 35px;
  transition: 0.5s ease;
  background-color: #e2e2e2;
}
.profile-pic span {
  background-color: rgba(226, 226, 226, 0.9);
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 22px;
  line-height: 22px;
  text-align: center;
  opacity: 1;
  transition: 0.5s ease;
  z-index: 10;
  cursor: pointer;
}

.remove-pic {
  top: 10px;
  width: 125px;
  margin: 0 auto;
  display: block;
  text-align: center;
  position: relative;
}

.animate-card-down-config {
  animation-duration: 1s;
  animation-name: animate-height-down-config;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-down-config {
  from {
    height: 200px;
  }
  to {
    height: 430px;
  }
}
.animate-card-up-config {
  animation-duration: 1s;
  animation-name: animate-height-up-config;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-up-config {
  from {
    height: 430px;
  }
  to {
    height: 200px;
  }
}
#image {
  width: 100%;
  margin-bottom: 20px;
}

.btn-registrar {
  margin: 20px;
}

.hidden-image {
  display: none;
}

.token-modal {
  max-width: 450px;
}

.token-modal-description {
  text-align: justify;
}

.token-modal-body {
  padding: 24px;
}

.erro {
  color: #e95021;
  font-weight: bold;
}

.input_group {
  display: flex;
}

.btn-copiar {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.token-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  text-align: center;
}

.container-loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.token-button {
  cursor: pointer;
}

.toast {
  position: fixed;
  width: 100px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  line-height: 50px;
  animation: toast 2s forwards;
  opacity: 0;
  z-index: 101;
}

@keyframes toast {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/configuracoes/card-geral/card-geral.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,UAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAAJ;AAEQ;EACI,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBCGA;ADHZ;AAGI;EACI,0CAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AADR;;AAKA;EACI,SAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,0CAAA;EACA,6BAAA;EACA,uBAAA;AAFJ;;AAKA;EACI;IACI,aAAA;EAFN;EAIE;IACI,aAAA;EAFN;AACF;AAKA;EACI,sBAAA;EACA,wCAAA;EACA,6BAAA;EACA,uBAAA;AAHJ;;AAMA;EACI;IACI,aAAA;EAHN;EAKE;IACI,aAAA;EAHN;AACF;AAMA;EACI,WAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,cAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,oCAAA;EACA,uCAAA;AAJJ;;AAOA;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;AAJJ;;AAOA;EACI;IACI,UAAA;EAJN;EAME;IACI,UAAA;EAJN;EAME;IACI,UAAA;EAJN;AACF","sourcesContent":["@import '../../../../../../../sass/variables';\n.modal-body {\n    padding: 0;\n}\n\n.profile-pic {\n    position: relative;\n    width: 140px;\n    height: 100px;\n    border: 1px solid $cinza-300;\n    margin: 0 auto;\n    cursor: pointer;\n    &:hover {\n        span {\n            height: 35px;\n            line-height: 35px;\n            transition: 0.5s ease;\n            background-color: $cinza-300;\n        }\n    }\n    span {\n        background-color: rgba($cinza-300, .9);\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        left: 0;\n        height: 22px;\n        line-height: 22px;\n        text-align: center;\n        opacity: 1;\n        transition: 0.5s ease;\n        z-index: 10;\n        cursor: pointer;\n    }\n}\n\n.remove-pic {\n    top: 10px;\n    width: 125px;\n    margin: 0 auto;\n    display: block;\n    text-align: center;\n    position: relative;\n}\n\n.animate-card-down-config {\n    animation-duration: 1s;\n    animation-name: animate-height-down-config;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-down-config {\n    from {\n        height: 200px;\n    }\n    to {\n        height: 430px;\n    }\n}\n\n.animate-card-up-config {\n    animation-duration: 1s;\n    animation-name: animate-height-up-config;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-up-config {\n    from {\n        height: 430px;\n    }\n    to {\n        height: 200px;\n    }\n}\n\n#image {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.btn-registrar {\n    margin: 20px;\n}\n\n.hidden-image {\n    display: none;\n}\n\n.token-modal {\n    max-width: 450px\n}\n\n.token-modal-description {\n    text-align: justify;\n}\n\n.token-modal-body {\n    padding: 24px;\n}\n\n.erro {\n    color: #e95021;\n    font-weight: bold;\n}\n\n.input_group {\n    display: flex;\n}\n\n.btn-copiar {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n}\n\n.token-input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    text-align: center;\n}\n\n.container-loading {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.token-button {\n    cursor: pointer;\n}\n  \n.toast {\n    position: fixed;\n    width: 100px;\n    height: 50px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(0, 0, 0, 0.5);\n    color: #FFF;\n    border-radius: 50px;\n    text-align: center;\n    line-height: 50px;\n    animation: toast 2s forwards;\n    opacity: 0;\n    z-index: 101;\n}\n  \n@keyframes toast {\n    0% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
